import React, { lazy, Suspense } from "react";

import { Navigate, Route, Routes } from "react-router-dom";

// import UserData from "../User/UserData";
import TeamMembers from "../Member/TeamMembers";

import Screener from "../Screener/Screener";
import SavedScan from "../SavedScan/SavedScan";
import PrivateRoute from "./PrivateRoutes";

// import UserProfile from "../components/UserProfilePage/UserProfile";
import LoginScreen from "../components/LoginScreen/LoginScreen";
import NotFound from "../components/NotFound";
import AdsPage from "../pages/ads";
import AdminLayout from "../Layout/AdminLayout";
// import { TestLayout } from "../pages/test/TestLayout";
// import { TVChartContainer } from "../components/TVChartContainer";
// import ChartLayout from "./ChartLayout";
import DashboardList from "../components/dashboards/DashboardList";
import SingleDashboardPage from "../components/dashboards/SingleDashboardPage";
// import OptionChain from "../pages/optionchain/SingleOptionChainItem";
// import EmailVerificationPage from "../pages/EmailVerificationPage";
import WatchlistPage from "../pages/watchlists";
import SingleWatchlistPage from "../components/watchlist/SingleWatchlistPage";
import EditWatchlistForm from "../components/watchlist/EditWatchlistForm";
import CreateWatchlistForm from "../components/watchlist/CreateWatchlistForm";
import AlertsPage from "../pages/alerts";
// import AdminAlertsPage from "../pages/adminAlerts";
// import SymbolAlertDetailsPage from "../components/adminAlerts/SymbolAlertDetailsPage";
import Pricing from "../pages/pricing";
import AddOnsForm from "../pages/addOnsForm";
import CartPage from "../pages/cart";
import PaymentSuccess from "../pages/PaymentSuccess";
import PaymentFailure from "../pages/PaymentFailure";
import PayPal from "../components/payment-gateways/PayPal";
// import UserDashboardPage from "../pages/user-dashboard";
import UserDashboardLayout from "../Layout/UserDashboardLayout";
import UserDashboardHome from "../components/UserDashboard";
import UserPayments from "../components/UserDashboard/Payments";
import UserReferrals from "../components/UserDashboard/Comissions";
import UserSupport from "../components/UserDashboard/Support";
import UserTrading from "../components/UserDashboard/Trading";
import UserProfile from "../components/UserDashboard/Profile";
import AdminDashboardLayout from "../Layout/AdminDashboardLayout";
import SymbolAlertDetailsPage from "../components/AdminDashboard/Alerts/SymbolAlertDetailsPage";
import AdminAlertsPage from "../components/AdminDashboard/Alerts";
import HomePage from "../pages/HomePage";
import HomePageLayout from "../Layout/HomePageLayout";
import RecommendedStocksPage from "../pages/recommended-stocks";
import SearchResultsPage from "../pages/SearchResultsPage";
import RefundsAndCancellation from "../pages/refunds-cancellation";
import PrivacyPolicy from "../pages/privacy-policy";
import TermsAndConditions from "../pages/terms-conditions";
import ContactUs from "../pages/contact-us";
import ForgetPasswordPage from "../pages/forget-password/ForgetPasswordPage";
import ResetPasswordPage from "../pages/reset-password/ResetPasswordPage";
import VerifyEmailCodePage from "../pages/verify-email-code/VerifyEmailCodePage";
import UserDevices from "../components/UserDashboard/Devices";
import OptionChainPage from "../pages/optionchain";
import SingleOptionChainItem from "../pages/optionchain/SingleOptionChainItem";
import UnderConstruction from "../components/UnderConstruction";
import SingleSavedScanPage from "../pages/singleSavedScanPage";
import TradeDashboard from "../pages/niftyBankNifty";
import UserInfoDashboard from "../pages/user-dashboard/index";
// import EmailUpdateVerify from "../pages/email-update-verify";
import { useSelector } from "react-redux";
import VerifyEmailPrompt from "../components/VerifyEmailPrompt";
import SingleUserReferralTable from "../components/AdminDashboard/SingleUserReferralTable";
import UserCouponCodesPage from "../components/AdminDashboard/UserCouponCodesPage";
import SubscriptionPlan from "../components/UserDashboard/SubscriptionPlan";
import UserSettings from "../components/UserDashboard/Settings";
import ActivateUserAccount from "../pages/activate-account";
import GuestLayout from "../Layout/GuestLayout";
import CreateMarqueeForm from "../components/AdminDashboard/CreateMarqueeForm";
import AdminDashboard from "../components/AdminDashboard";
import AdminRoute from "./AdminRoute";
import ReferralRewardProgram from "../components/AdminDashboard/ReferralRewardProgram";
import PaymentsDashboard from "../components/AdminDashboard/PaymentsDashboard";
import SingleUserPaymentsTable from "../components/AdminDashboard/PaymentsDashboard/UserPaymentsDashboardTable/SingleUserPaymentsTable";
import SubscriptionsPlans from "../components/AdminDashboard/SubscriptionsPlans";
import CreateTopUp from "../components/AdminDashboard/CreateTopUp";
// import PreviousTradesPerformance from "../pages/previous-trades-performance";
import ThanksForPaying from "../components/common/ThanksForPaying";
import HomeScreenContent from "../components/AdminDashboard/HomeScreenContent";
// import UserSupportPanel from "../components/AdminDashboard/UserSupportPanel";
import SinglePaymentDetails from "../components/UserDashboard/Payments/SinglePaymentDetails";
import SingleTicketPageComments from "../pages/SingleTicketPageComments";
import UserRefund from "../components/UserDashboard/UserRefund";
import AdminRefunds from "../components/AdminDashboard/AdminRefunds";
import RefundDashboard from "../components/AdminDashboard/RefundDashboard";
import RefundModuleAccess from "../components/AdminDashboard/RefundModuleAccess";
import UploadBanners from "../components/AdminDashboard/UploadBanners";
// import AdvisorDashboard from "../components/AdvisorDashboard";
import AdvisorDashboardLayout from "../Layout/AdvisorLayout";
import AdvisorHome from "../components/AdvisorDashboard/AdvisorHome";
import AdvisorUserSupport from "../components/AdvisorDashboard/AdvisorUserSupport";
import AdvisorDashboard from "../components/AdvisorDashboard";
import AdvisorRoute from "./AdvisorRoute";
import AdvisorHomeBanner from "../components/AdvisorDashboard/AdvisorHomeBanner";
import AdvisorTradeCalls from "../components/AdvisorDashboard/AdvisorTradeCalls";
import AgentDashboardLayout from "../Layout/AgentLayout";
import AgentRoute from "./AgentRoute";
import AgentDashboard from "../components/AgentDashboard";
import CustomerJourneyDashboard from "../pages/customer-journey";
import InvestorDashboardLayout from "../Layout/InvestorLayout";
import InvestorRoute from "./InvestorRoute";
import ReferralDashboardLayout from "../Layout/ReferralLayout";
import ReferralRoute from "./ReferralRoute";
import ReferralDashboard from "../pages/referral-dashboard";
import ReferralBroker from "../pages/referral-dashboard/Broker";
import ReferralBDM from "../pages/referral-dashboard/BDM";
import ReferralSubBroker from "../pages/referral-dashboard/SubBroker";
import ReferralEndUser from "../pages/referral-dashboard/EndUser";
import InvestorDashboard from "../components/InvestorDashboard";
import TotalClientsPage from "../components/InvestorDashboard/TotalClientsPage";
import NewClientsTodayPage from "../components/InvestorDashboard/NewClientsTodayPage";
import TotalSubscribersPage from "../components/InvestorDashboard/TotalSubscribersPage";
import ActiveUsersPage from "../components/InvestorDashboard/ActiveUsersPage";
import ActiveSubscribersPage from "../components/InvestorDashboard/ActiveSubscribersPage";
import ActiveUsersYesterdayPage from "../components/InvestorDashboard/ActiveUsersYesterdayPage";
import AgentStockAdvisoryHistory from "../components/AgentDashboard/stockAdvistoryHis";
import TradeHistory from "../components/AgentDashboard/tradeHistory";
import UserRating from "../pages/user-rating";
import { Box, CircularProgress } from "@mui/material";
import UsersSubscriptionDetails from "../pages/users-subscription-details/UsersSubscriptionDetails";
import SubscriptionCommisions from "../components/AdminDashboard/SubscriptionCommisions";
import UserComissions from "../components/UserDashboard/Comissions";
import UserReferral from "../pages/user-referral";
import TickerConfiguration from "../Layout/TickerConfiguration";
import CreateScreenName from "../components/AdminDashboard/CreateScreenName/CreateScreenName";
import HomeScreenConfigurationLayout from "../Layout/HomeScreenConfigurationLayout";
import ForTesting from "../pages/One SIgnals";
import OneSignals from "../pages/One SIgnals";
import ConversionAnalytics from "../pages/conversion-analytics";
import PaymentGatewayConfiguration from "../pages/payment-gateway-configuration";
import UserWithdrawal from "../pages/user-referral/UserWithdrawal";
import AppConfiguration from "../components/AdminDashboard/AppConfiguration";
import StockForAlerts from "../pages/stock-for-alerts";
import InvoiceDashboard from "../pages/invoice-dashboard";
import AlertsManagement from "../pages/alertsManagementAcess";
import PushNotifications from "../pages/One SIgnals/PushNotifications";
import IntroScreenConfigurations from "../pages/introScreenConfiguration";
// import AlertsSetByStockyaari from "../pages/alertsManagementAcess/AlertsSetByStockyaari";
// import SetSignalsDB from "../pages/alertsManagementAcess/SetSignalsDB";
import OptionsDashboard from "../pages/option-management";
import StockSplit from "../pages/stock-split";
import OptionsDisclaimer from "../pages/option-management/OptionsDisclaimer";
import OptionRecommendations from "../pages/option-management/OptionRecommendations";
import FutureRecommendations from "../pages/option-management/FutureRecommendations";
import PaymentLink from "../pages/payment-link";
import CreateQR from "../pages/create-qr";
import FutureManagement from "../pages/futures-management/FutureManagement";
import BrokerIntegration from "../pages/broker-integration";
import GiveBrokerAccess from "../pages/broker/GiveBrokerAccess";
import BrokerConnectivity from "../pages/broker-connectivity/BrokerConnectivity";
import OpenTradesPage from "../pages/broker/OpenTradesPage";
import TradeDashboardPage from "../pages/broker/TradeDashboardPage";
import TradeDashboardSymbolwise from "../pages/broker/TradeDashboardSymbolwise";
import TradeDashboardSymbolwiseDrilldown from "../pages/broker/TradeDashboardSymbolwiseDrilldown";
import SymbolBrokerList from "../pages/broker/SymbolBrokerList";
import SymbolBrokerUserList from "../pages/broker/SymbolBrokerUserList";
import SymbolUserTradeHistory from "../pages/broker/SymbolUserTradeHistory";
import CustomerTradeInfo from "../pages/broker/CustomerTradeInfo";
import BrokerTradeInfo from "../pages/broker/BrokerTradeInfo";
import MainModuleConfig from "../pages/home-module-config/MainModuleConfig";
import SubModuleConfig from "../pages/home-module-config/SubModuleConfig";
import ModuleMapping from "../pages/home-module-config/ModuleMapping";
import MainSubMapping from "../pages/home-module-config/MainSubMapping";
import FailedPaymentsPage from "../pages/failed-payments";
import AutopayRecords from "../pages/autopay-records";
import ProfitCards from "../pages/profit-cards";
import PerformanceCards from "../pages/performance-cards";
import ExpiredUserDashboard from "../pages/expired-user-dashboard";
import PlanExtensionList from "../pages/plan-extension-list";
import PlanChangeList from "../pages/plan-change-list";
import BrokerConnect from "../pages/broker-integration/components/BrokerConnect/BrokerConnect";
import BrokerOTP from "../pages/broker-integration/components/BrokerOTP/BrokerOTP";
import BrokerPassword from "../pages/broker-integration/components/BrokerPassword/BrokerPassword";
import TradingOrder from "../pages/broker-integration/components/TradingOrder/TradingOrder";
import LoginUsersHistory from "../pages/Login-Users";
import TradingActivityDashboard from "../pages/trading-activity-dashboard";
import AdvisorPerformanceDashboard from "../pages/advisor-performance";
import LocationHistoryPage from "../pages/location-history";
import NewsPage from "../pages/news";
import AppEventsPage from "../components/InvestorDashboard/AppEventsPage";
import UserActivityPage from "../components/InvestorDashboard/UserActivityPage";
import EventLogUserDetails from "../components/InvestorDashboard/EventLogUserDetails";
import EventLogDateWise from "../components/InvestorDashboard/EventLogDateWise";
import MarketingChannel from "../components/MarketingDashboard/MarketingChannel";
import MarketingSpend from "../components/MarketingDashboard/MarketingSpend";
import InvestorMarketingSpend from "../components/InvestorDashboard/InvestorMarketingSpend";
import BasketManagement from "../pages/basket-management/BasketManagement";
import TNITrading from "../pages/tni-trading/TNITrading";
// const advisorToken = JSON.parse(localStorage.getItem('advisor_token'));

// ['admin'] means only admin can access. ['advisor', 'admin'] means both advisor and admin can access.
// Since admin should be able to access everything, so 'admin' is included in every list (array)
const USER_TYPES = {
  admin: ["admin"],
  trial: ["trial", "admin"],
  premium: ["premium", "admin"],
  guest: ["guest", "admin"],
  // advisor: ['advisor'],
  advisor: ["advisor", "masteradvisor", "admin"],
  marketing: ["marketing", "admin"],
  investor: ["investor", "admin"],
  all: ["admin", "trial", "premium", "guest", "advisor", "masteradvisor"],
};

const Users = lazy(() => import("../components/AdminDashboard/Users"));
const UserSubscriptionPage = lazy(() => import("../pages/user-subscription"));
const UserSupportPanel = lazy(() =>
  import("../components/AdminDashboard/UserSupportPanel")
);
const AlertsSetByStockyaari = lazy(() =>
  import("../pages/alertsManagementAcess/AlertsSetByStockyaari")
);

const SetSignalsDB = lazy(() =>
  import("../pages/alertsManagementAcess/SetSignalsDB")
);

const AppRoutes = () => {
  const userState = useSelector((store) => store.auth);
  const user = userState?.user;
  const USER_DETAILS = userState?.user?.userDetails;

  // if (!user) {
  //   return (<LoginScreen />)
  // }

  return (
    <Suspense
      fallback={
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <CircularProgress />
        </Box>
      }
    >
      <Routes>
        <Route path="/" element={<UnderConstruction />} />

        <Route path="/" element={<HomePageLayout />}>
          {/* <Route index element={<HomePage />} /> */}
          <Route path="home" element={<HomePage />} />
          <Route path="privacy-policy" element={<PrivacyPolicy />} />
          <Route
            path="refunds-cancellation"
            element={<RefundsAndCancellation />}
          />
          <Route path="terms-conditions" element={<TermsAndConditions />} />
          <Route path="contact-us" element={<ContactUs />} />

          <Route path="pricing" element={<Pricing />} />
          {/* <Route path="cart" element={<CartPage />} /> */}
          <Route path="addons" element={<AddOnsForm />} />
        </Route>

        {/* ADVISOR DASHBOARD PANEL */}
        {/* <Route path="/advisor" element={<PrivateRoute allowedRoles={USER_TYPES.advisor} auth={{ isAuthenticated: !!user }}><AdvisorDashboardLayout /></PrivateRoute>} >
            <Route index element={<PrivateRoute allowedRoles={USER_TYPES.advisor} auth={{ isAuthenticated: !!user }}><AdvisorDashboard /></PrivateRoute>}/>
            <Route path="home" element={<PrivateRoute allowedRoles={USER_TYPES.advisor} auth={{ isAuthenticated: !!user }}><AdvisorHome /></PrivateRoute>}/>
            <Route path="support" index element={<PrivateRoute allowedRoles={USER_TYPES.advisor} auth={{ isAuthenticated: !!user }}><AdvisorUserSupport /></PrivateRoute>}/>
          </Route> */}

        {/* ADVISOR DASHBOARD PANEL */}
        <Route
          path="/advisor"
          element={
            <AdvisorRoute
              allowedRoles={USER_TYPES.advisor}
              auth={{ isAuthenticated: !!user }}
            >
              <AdvisorDashboardLayout />
            </AdvisorRoute>
          }
        >
          {/* the default index home comp not needed as of now */}
          <Route index element={<AdvisorDashboard />} />
          <Route path="advisory-form" element={<AdvisorHome />} />
          <Route path="trade-calls" element={<AdvisorTradeCalls />} />
          <Route path="basket" element={<BasketManagement />} />
          <Route path="nifty" element={<TradeDashboard />} />
          <Route path="banner" element={<AdvisorHomeBanner />} />
          <Route path="user-support" element={<AdvisorUserSupport />} />
          <Route
            path="user-subscription-history"
            element={<UserSubscriptionPage />}
          />
          <Route path="user-rating" element={<UserRating />} />
          <Route path="stock-alerts" element={<StockForAlerts />} />
          <Route
            path="user-support/:ticketID"
            element={<SingleTicketPageComments userType="admin" />}
          />
          <Route path="create-ticker" element={<CreateMarqueeForm />} />
          {/* <Route path="coupons" element={<UserCouponCodesPage />} /> */}
          <Route
            path="home-screen-configuration"
            element={<HomeScreenConfigurationLayout />}
          >
            <Route path="upload-banners" element={<UploadBanners />} />
            <Route path="app-configuration" element={<AppConfiguration />} />
          </Route>

          <Route path="customer-info" element={<UserInfoDashboard />} />
          <Route path="invoice-dashboard" element={<InvoiceDashboard />} />
          <Route
            path="alerts-managements"
            element={<HomeScreenConfigurationLayout />}
          >
            <Route path="all-alerts" element={<AlertsManagement />} />
            <Route
              path="alerts-stockyaari"
              element={<AlertsSetByStockyaari />}
            />
            <Route path="signals-dashboard" element={<SetSignalsDB />} />
          </Route>
          <Route path="push-notifications" element={<PushNotifications />} />
          <Route path="one-signals" element={<OneSignals />} />
          <Route path="profit-cards" element={<ProfitCards />} />
          <Route path="performance-cards" element={<PerformanceCards />} />

          <Route path="intro-screens" element={<IntroScreenConfigurations />} />
          <Route
            path="options-dashboard"
            element={<HomeScreenConfigurationLayout />}
          >
            <Route index element={<OptionsDashboard />} />
            <Route path="disclaimer" element={<OptionsDisclaimer />} />
          </Route>
          <Route path="futures" element={<FutureManagement />} />
          <Route path="news" element={<NewsPage />} />
          <Route path="broker-access" element={<GiveBrokerAccess />} />
          <Route path="broker-trade" element={<HomeScreenConfigurationLayout />}>
            <Route path="trade-dashboard" element={<TradeDashboardPage />} />
            <Route path="trade-dashboard-symbolwise" element={<TradeDashboardSymbolwise />} />
            <Route path="trade-dashboard-symbolwise-drilldown" element={<TradeDashboardSymbolwiseDrilldown />} />
            <Route path="symbolwise/:symbolName/brokers" element={<SymbolBrokerList />} />
            <Route path="symbolwise/:symbolName/broker/:brokerName/users" element={<SymbolBrokerUserList />} />
            <Route path="symbolwise/:symbolName/broker/:brokerName/user/:clientId/trades" element={<SymbolUserTradeHistory />} />
            <Route path="open-trade" element={<OpenTradesPage />} />
            <Route path="customer-info/:clientId" element={<CustomerTradeInfo />} />
            <Route path="broker-info/:brokerId" element={<BrokerTradeInfo />} />
          </Route>
          <Route path="trading-activity" element={<TradingActivityDashboard />} />
        </Route>

        {/* Agent DASHBOARD PANEL */}
        <Route
          path="/agent"
          element={
            <AgentRoute
              allowedRoles={USER_TYPES.marketing}
              auth={{ isAuthenticated: !!user }}
            >
              <AgentDashboardLayout />
            </AgentRoute>
          }
        >
          {/* <Route path="home" element={<AgentDashboard />} /> */}

          <Route path="users" element={<Users />} />
          <Route path="push-notifications" element={<PushNotifications />} />
          <Route path="one-signals" element={<OneSignals />} />
          <Route path="conversion-analytics" element={<ConversionAnalytics />} />
          <Route path="customer-info" element={<UserInfoDashboard />} />
          <Route
            path="user-subscription-history"
            element={<UserSubscriptionPage />}
          />
          <Route path="user-rating" element={<UserRating />} />
          <Route path="user-support" element={<AdvisorUserSupport />} />
          <Route
            path="user-support/:ticketID"
            element={<SingleTicketPageComments userType="admin" />}
          />
          <Route path="stock-alerts" element={<StockForAlerts />} />
          <Route path="invoice-dashboard" element={<InvoiceDashboard />} />
          <Route path="intro-screens" element={<IntroScreenConfigurations />} />
          <Route path="profit-cards" element={<ProfitCards />} />
          <Route path="performance-cards" element={<PerformanceCards />} />
          <Route path="news" element={<NewsPage />} />
          <Route path="marketing-spend-analysis" element={<HomeScreenConfigurationLayout />}>
            <Route path="marketing-channel" element={<MarketingChannel />} />
            <Route path="marketing-spend" element={<MarketingSpend />} />
          </Route>
          <Route path="broker-connectivity" element={<BrokerConnectivity />} />
          <Route path="autopay-records" element={<AutopayRecords />} />
          <Route path="payments-dashboard" element={<PaymentsDashboard />} />
          <Route
            path="payments-dashboard/user/:userID"
            element={<SingleUserPaymentsTable />}
          />
          <Route path="user-refunds" element={<RefundDashboard />} />
          <Route path="failed-payments" element={<FailedPaymentsPage />} />
          <Route path="refund-module-access" element={<RefundModuleAccess />} />
          <Route path="trading-activity" element={<TradingActivityDashboard />} />
          <Route path="customer-journey" element={<CustomerJourneyDashboard />} />
          <Route path="coupons" element={<UserCouponCodesPage />} />
          <Route path="create-topup" element={<CreateTopUp />} />
          <Route path="payment-link" element={<PaymentLink />} />
          <Route path="create-qr" element={<CreateQR />} />
          <Route path="payment-gateway-configuration" element={<PaymentGatewayConfiguration />} />
          <Route
            path="create-plan"
            element={
              <PrivateRoute
                allowedRoles={USER_TYPES.admin}
                auth={{ isAuthenticated: !!user }}
              >
                <SubscriptionsPlans />
              </PrivateRoute>
            }
          />
        </Route>

        {/* INVESTOR DASHBOARD PANEL */}
        <Route
          path="/investor"
          element={
            <InvestorRoute
              allowedRoles={USER_TYPES.investor}
              auth={{ isAuthenticated: !!user }}
            >
              <InvestorDashboardLayout />
            </InvestorRoute>
          }
        >
          <Route index element={<InvestorDashboard />} />
          <Route path="total-clients" element={<TotalClientsPage />} />
          <Route path="new-clients-today" element={<NewClientsTodayPage />} />
          <Route path="total-subscribers" element={<TotalSubscribersPage />} />
          {/* <Route path="active-users" element={<ActiveUsersPage />} /> */}
          <Route path="active-subscribers" element={<ActiveSubscribersPage />} />
          <Route path="active-users-yesterday" element={<ActiveUsersYesterdayPage />} />
          <Route path="user-visit-count" element={<AppEventsPage />} />
          <Route path="event-log-user-details" element={<EventLogUserDetails />} />
          {/* <Route path="event-log-date-wise" element={<EventLogDateWise />} /> */}
          <Route path="user-activity" element={<UserActivityPage />} />
          <Route path="marketing-spend" element={<InvestorMarketingSpend />} />
        </Route>

        {/* REFERRAL DASHBOARD PANEL — gated on Premium user_type + SuperAdmin referral_role */}
        <Route
          path="/referral"
          element={
            <ReferralRoute auth={{ isAuthenticated: !!user }}>
              <ReferralDashboardLayout />
            </ReferralRoute>
          }
        >
          <Route index element={<ReferralDashboard />} />
          <Route path="broker" element={<ReferralBroker />} />
          <Route path="bdm" element={<ReferralBDM />} />
          <Route path="sub-broker" element={<ReferralSubBroker />} />
          <Route path="end-user" element={<ReferralEndUser />} />
        </Route>

        {/* Old standalone team view — every referral role now uses the /referral dashboard */}
        <Route path="/my-team" element={<Navigate to="/referral" replace />} />

        {/* ADMIN DASHBOARD ROUTE - AUTH REQUIRED, allowedRoles should be updated in both root/parent Route and subroutes */}
        <Route
          path="/"
          element={
            <PrivateRoute
              allowedRoles={USER_TYPES.all}
              auth={{ isAuthenticated: !!user }}
            >
              <AdminLayout />
            </PrivateRoute>
          }
        >
          {/* <Route path="/" element={<HomePageLayout />} >
            <Route index element={<HomePage />} /> */}
          {/* <Route path="home" element={<HomePage />} /> */}
          {/* ONLY FOR THE ADMIN */}

          <Route
            path="screener"
            element={
              <PrivateRoute
                allowedRoles={USER_TYPES.all}
                auth={{ isAuthenticated: !!user }}
              >
                <Screener />
              </PrivateRoute>
            }
          />
          <Route
            path="recommended-stocks"
            element={
              <PrivateRoute
                allowedRoles={USER_TYPES.all}
                auth={{ isAuthenticated: !!user }}
              >
                <RecommendedStocksPage />
              </PrivateRoute>
            }
          />

          {/* COMMENTED OUT THE ADMIN DASHBOARD PAGES/COMPONENTS, as not needed */}
          {/* <Route path="users" element={<PrivateRoute allowedRoles={['admin']} auth={{ isAuthenticated: !!user }}><UserData /></PrivateRoute>}/>
            <Route path="members" element={<PrivateRoute allowedRoles={['admin']} auth={{ isAuthenticated: !!user }}><TeamMembers /></PrivateRoute>}/>
            <Route path="ads" element={<PrivateRoute allowedRoles={['admin']} auth={{ isAuthenticated: !!user }}><AdsPage /></PrivateRoute>}/> */}

          <Route
            path="savedscan"
            element={
              <PrivateRoute
                allowedRoles={USER_TYPES.all}
                auth={{ isAuthenticated: !!user }}
              >
                <SavedScan />
              </PrivateRoute>
            }
          />
          <Route
            path="savedscan/:screenerId"
            element={
              <PrivateRoute
                allowedRoles={USER_TYPES.all}
                auth={{ isAuthenticated: !!user }}
              >
                <SingleSavedScanPage />
              </PrivateRoute>
            }
          />
          {/* <Route path="profile" element={<PrivateRoute allowedRoles={['admin', 'free', 'trial', 'premium']} auth={{ isAuthenticated: !!user }}><UserProfile /></PrivateRoute>}/> */}
          {/* <Route path="nse-option-chain" element={<PrivateRoute allowedRoles={USER_TYPES.all} auth={{ isAuthenticated: !!user }}><OptionChain /></PrivateRoute>}/> */}
          <Route
            path="nse-option-chain"
            element={
              <PrivateRoute
                allowedRoles={USER_TYPES.all}
                auth={{ isAuthenticated: !!user }}
              >
                <OptionChainPage />
              </PrivateRoute>
            }
          />
          <Route
            path="nse-option-chain/:option_symbol"
            element={
              <PrivateRoute
                allowedRoles={USER_TYPES.all}
                auth={{ isAuthenticated: !!user }}
              >
                <SingleOptionChainItem />
              </PrivateRoute>
            }
          />

          {/* IMP: DISABLED AS WEB APP IS NOT LIVE */}
          {/* <Route path="previous-trades-performance" element={<PrivateRoute allowedRoles={USER_TYPES.all} auth={{ isAuthenticated: !!user }}><PreviousTradesPerformance /></PrivateRoute>}/> */}
          {/* <Route path="user-dashboard" element={<PrivateRoute allowedRoles={USER_TYPES.all} auth={{ isAuthenticated: !!user }}><UserDashboardPage /></PrivateRoute>}/> */}

          {/* SEARCH RESULTS */}
          <Route path="search-results" element={<SearchResultsPage />} />

          {/* temp cart */}
          <Route path="cart" element={<CartPage />} />

          {/* DASHBOARDS ROUTE */}
          {/* IMP: REMOVED FROM NAVBAR MENU AS WEB APP IS NOT LIVE */}
          <Route path="dashboards">
            <Route
              index
              element={
                <PrivateRoute
                  allowedRoles={USER_TYPES.all}
                  auth={{ isAuthenticated: !!user }}
                >
                  <DashboardList />
                </PrivateRoute>
              }
            />
            <Route
              path=":dashboardId"
              element={
                <PrivateRoute
                  allowedRoles={USER_TYPES.all}
                  auth={{ isAuthenticated: !!user }}
                >
                  <SingleDashboardPage />
                </PrivateRoute>
              }
            />
          </Route>

          {/* WATCHLIST ROUTES */}
          <Route path="watchlist">
            <Route
              index
              element={
                <PrivateRoute
                  allowedRoles={USER_TYPES.all}
                  auth={{ isAuthenticated: !!user }}
                >
                  <WatchlistPage />
                </PrivateRoute>
              }
            />
            <Route
              path=":watchlistId"
              element={
                <PrivateRoute
                  allowedRoles={USER_TYPES.all}
                  auth={{ isAuthenticated: !!user }}
                >
                  <SingleWatchlistPage />
                </PrivateRoute>
              }
            />
            <Route
              path="edit/:watchlistId"
              element={
                <PrivateRoute
                  allowedRoles={USER_TYPES.all}
                  auth={{ isAuthenticated: !!user }}
                >
                  <EditWatchlistForm />
                </PrivateRoute>
              }
            />
            <Route
              path="create"
              element={
                <PrivateRoute
                  allowedRoles={USER_TYPES.all}
                  auth={{ isAuthenticated: !!user }}
                >
                  <CreateWatchlistForm />
                </PrivateRoute>
              }
            />
          </Route>

          {/* ALERTS ROUTES */}
          <Route path="alerts">
            <Route
              index
              element={
                <PrivateRoute
                  allowedRoles={USER_TYPES.all}
                  auth={{ isAuthenticated: !!user }}
                >
                  <AlertsPage />
                </PrivateRoute>
              }
            />
          </Route>

          {/* ROUTES ACCESSIBLE TO EVERY WITH NAVBAR - GUEST LAYOUT */}
          {/* PRIVACY, REFUNDS & CANCELLATION POLICIES */}
          {/* <Route path="privacy-policy" element={<PrivacyPolicy />} />
            <Route path="refunds-cancellation" element={<RefundsAndCancellation />} />
            <Route path="terms-conditions" element={<TermsAndConditions />} />
            <Route path="contact-us" element={<ContactUs />} /> */}

          {/* ALERTS ADMIN ROUTES */}
          {/* <Route path="alerts-admin" >
              <Route index element={<PrivateRoute allowedRoles={['admin']} auth={{ isAuthenticated: !!user }}><AdminAlertsPage /></PrivateRoute>}/>
              <Route path=":symbol" element={<PrivateRoute allowedRoles={['admin']} auth={{ isAuthenticated: !!user }}><SymbolAlertDetailsPage /></PrivateRoute>}/>
            </Route> */}

          {/* <Route path="chart" element={<TVChartContainer />} /> */}
        </Route>

        {/* ADMIN DASHBOARD LAYOUT */}
        {/* <Route path="/admin" element={<AdminDashboardLayout />} > */}
        <Route
          path="/admin"
          element={
            <AdminRoute
              allowedRoles={USER_TYPES.admin}
              auth={{ isAuthenticated: !!user }}
            >
              <AdminDashboardLayout />
            </AdminRoute>
          }
        >
          <Route index element={<AdminDashboard />} />
          <Route path="basket" element={<BasketManagement />} />
          <Route path="tni-trading" element={<TNITrading />} />
          <Route path="users" element={<Users />} />
          <Route
            path="Subscription-Details"
            element={<UsersSubscriptionDetails />}
          />
          <Route path="nifty" element={<TradeDashboard />} />
          <Route path="customer-info" element={<UserInfoDashboard />} />
          <Route
            path="user-subscription-history"
            element={<UserSubscriptionPage />}
          />
          <Route path="user-rating" element={<UserRating />} />
          <Route path="stock-alerts" element={<StockForAlerts />} />
          <Route path="stock-split" element={<StockSplit />} />

          {/* <Route path="user-referral" element={<UserReferral />} /> */}
          <Route
            path="influencer-Management"
            element={<HomeScreenConfigurationLayout />}
          >
            <Route path="user-referral" element={<UserReferral />} />
            <Route path="withdrawal" element={<UserWithdrawal />} />
          </Route>

          <Route
            path="users/:referralCode"
            element={<SingleUserReferralTable />}
          />
          <Route path="members" element={<TeamMembers />} />
          <Route path="coupons" element={<UserCouponCodesPage />} />
          <Route path="ads" element={<AdsPage />} />
          <Route path="ticker-configuration" element={<TickerConfiguration />}>
            <Route path="screen-name" element={<CreateScreenName />} />
            <Route path="create-ticker" element={<CreateMarqueeForm />} />
          </Route>
          {/* <Route path="create-ticker" element={<CreateMarqueeForm />} /> */}
          <Route
            path="create-referral-program"
            element={<ReferralRewardProgram />}
          />
          <Route path="payments-dashboard" element={<PaymentsDashboard />} />
          <Route path="invoice-dashboard" element={<InvoiceDashboard />} />
          <Route
            path="alerts-managements"
            element={<HomeScreenConfigurationLayout />}
          >
            <Route path="all-alerts" element={<AlertsManagement />} />
            <Route
              path="alerts-stockyaari"
              element={<AlertsSetByStockyaari />}
            />
            <Route path="signals-dashboard" element={<SetSignalsDB />} />
          </Route>
          <Route path="push-notifications" element={<PushNotifications />} />
          <Route
            path="options-dashboard"
            element={<HomeScreenConfigurationLayout />}
          >
            <Route index element={<OptionsDashboard />} />
            <Route path="disclaimer" element={<OptionsDisclaimer />} />
            <Route path="recommendations" element={<OptionRecommendations />} />
            <Route path="future-recommendations" element={<FutureRecommendations />} />
          </Route>
          <Route path="intro-screens" element={<IntroScreenConfigurations />} />
          <Route path="futures" element={<FutureManagement />} />

          <Route
            path="subscription-commisions"
            element={<SubscriptionCommisions />}
          />
          <Route
            path="payments-dashboard/user/:userID"
            element={<SingleUserPaymentsTable />}
          />
          <Route path="alerts" element={<AdminAlertsPage />} />
          <Route path="alerts/:symbol" element={<SymbolAlertDetailsPage />} />
          <Route path="create-plan" element={<SubscriptionsPlans />} />
          <Route path="create-topup" element={<CreateTopUp />} />
          <Route path="payment-link" element={<PaymentLink />} />
          <Route path="create-qr" element={<CreateQR />} />
          <Route path="payment-gateway-configuration" element={<PaymentGatewayConfiguration />} />
          <Route path="home-module-config" element={<HomeScreenConfigurationLayout />}>
            <Route path="main-module" element={<MainModuleConfig />} />
            <Route path="sub-module" element={<SubModuleConfig />} />
            <Route path="module-mapping" element={<ModuleMapping />} />
            <Route path="main-sub-mapping" element={<MainSubMapping />} />
          </Route>

          <Route
            path="home-screen-configuration"
            element={<HomeScreenConfigurationLayout />}
          >
            <Route path="home-screen-content" element={<HomeScreenContent />} />
            <Route path="upload-banners" element={<UploadBanners />} />
            <Route path="app-configuration" element={<AppConfiguration />} />
          </Route>

          <Route path="user-support" element={<UserSupportPanel />} />
          <Route path="one-signals" element={<OneSignals />} />
          <Route path="conversion-analytics" element={<ConversionAnalytics />} />
          <Route path="profit-cards" element={<ProfitCards />} />
          <Route path="performance-cards" element={<PerformanceCards />} />
          <Route
            path="user-support/:ticketID"
            element={<SingleTicketPageComments userType="admin" />}
          />
          <Route path="user-refunds" element={<RefundDashboard />} />
          <Route path="failed-payments" element={<FailedPaymentsPage />} />
          <Route path="autopay-records" element={<AutopayRecords />} />
          <Route path="refund-module-access" element={<RefundModuleAccess />} />
          <Route path="upload-banners" element={<UploadBanners />} />
          <Route path="expired-users" element={<HomeScreenConfigurationLayout />}>
            <Route index element={<ExpiredUserDashboard />} />
            <Route path="plan-extensions" element={<PlanExtensionList />} />
            <Route path="plan-changes" element={<PlanChangeList />} />
          </Route>
          <Route path="login-history" element={<LoginUsersHistory />} />
          <Route path="trading-activity" element={<TradingActivityDashboard />} />
          <Route path="advisor-performance" element={<AdvisorPerformanceDashboard />} />
          <Route path="location-history" element={<LocationHistoryPage />} />
          <Route path="news" element={<NewsPage />} />
          <Route path="marketing-spend-analysis" element={<HomeScreenConfigurationLayout />}>
            <Route path="marketing-channel" element={<MarketingChannel />} />
            <Route path="marketing-spend" element={<MarketingSpend />} />
          </Route>
          <Route path="broker-access" element={<GiveBrokerAccess />} />
          <Route path="broker-connectivity" element={<BrokerConnectivity />} />
          <Route path="broker-trade" element={<HomeScreenConfigurationLayout />}>
            <Route path="trade-dashboard" element={<TradeDashboardPage />} />
            <Route path="trade-dashboard-symbolwise" element={<TradeDashboardSymbolwise />} />
            <Route path="trade-dashboard-symbolwise-drilldown" element={<TradeDashboardSymbolwiseDrilldown />} />
            <Route path="symbolwise/:symbolName/brokers" element={<SymbolBrokerList />} />
            <Route path="symbolwise/:symbolName/broker/:brokerName/users" element={<SymbolBrokerUserList />} />
            <Route path="symbolwise/:symbolName/broker/:brokerName/user/:clientId/trades" element={<SymbolUserTradeHistory />} />
            <Route path="open-trade" element={<OpenTradesPage />} />
            <Route path="customer-info/:clientId" element={<CustomerTradeInfo />} />
            <Route path="broker-info/:brokerId" element={<BrokerTradeInfo />} />
          </Route>
        </Route>

        {/* USER DASHBOARD LAYOUT & PAGES */}
        {/* <Route path="/user-dashboard" element={<UserDashboardLayout />} > */}
        <Route
          path="/user-dashboard"
          element={
            <PrivateRoute
              allowedRoles={USER_TYPES.all}
              auth={{ isAuthenticated: !!user }}
            >
              <UserDashboardLayout />
            </PrivateRoute>
          }
        >
          <Route index element={<UserDashboardHome />} />
          <Route path="profile" element={<UserProfile />} />
          <Route path="subscription" element={<SubscriptionPlan />} />
          <Route path="devices" element={<UserDevices />} />
          <Route path="payments" element={<UserPayments />} />
          <Route
            path="payments/:paymentID"
            element={<SinglePaymentDetails />}
          />
          <Route path="referrals" element={<UserComissions />} />
          <Route path="support" element={<UserSupport />} />
          <Route
            path="support/:ticketID"
            element={<SingleTicketPageComments userType="user" />}
          />
          <Route path="settings" element={<UserSettings />} />
          <Route path="refund" element={<UserRefund />} />
          <Route path="trading" element={<UserTrading />} />
        </Route>

        {/* ROUTES ACCESSIBLE TO EVERYONE */}
        {/* <Route path="login" element={<SignInPage />} />
            <Route path="register" element={<SignUpPage />} /> */}
        <Route path="login" element={<LoginScreen />} />
        <Route path="register" element={<LoginScreen />} />
        {/* <Route path="email-verify" element={<EmailVerificationPage />} /> */}
        <Route
          path="email-update-verify"
          element={<VerifyEmailPrompt userDetails={USER_DETAILS} />}
        />
        <Route path="thanks-for-paying" element={<ThanksForPaying />} />

        {/* <Route path="pricing" element={<Pricing />} /> */}
        {/* Error in AddOns comp (check auth userDetails) */}
        {/* <Route path="addons" element={<AddOnsForm />} />   */}
        <Route path="payment-success" element={<PaymentSuccess />} />
        <Route path="payment-failure" element={<PaymentFailure />} />
        <Route path="paypal" element={<PayPal />} />

        {/* FORGET & RESET PASSWORD */}
        <Route path="forget-password" element={<ForgetPasswordPage />} />
        <Route path="verify-email-code" element={<VerifyEmailCodePage />} />
        <Route path="reset-password" element={<ResetPasswordPage />} />

        {/* BROKER INTEGRATION - OPEN ROUTE */}
        <Route path="broker-integration" element={<BrokerIntegration />} />
        <Route
          path="broker-integration/:name"
          element={<BrokerConnect />}
        />
        <Route
          path="broker-integration/:name/verify-otp"
          element={<BrokerOTP />}
        />
        <Route
          path="broker-integration/:name/password"
          element={<BrokerPassword />}
        />
        <Route
          path="broker-integration/:name/trading"
          element={<TradingOrder />}
        />

        {/* GUEST LAYOUT */}
        <Route path="/activate-account" element={<GuestLayout />}>
          <Route index element={<ActivateUserAccount />} />
        </Route>

        {/* CHARTING LIBRARY */}
        {/* <Route path="/chart" element={<ChartLayout />} >
            <Route index element={<TVChartContainer />} />
          </Route> */}

        {/* 404 NOT FOUND ROUTE */}
        <Route path="*" element={<NotFound />} />

        {/* ROUTE FOR TESTING */}
        {/* <Route exact path="/test" element={<TestLayout />}>
            <Route path="test" element={<h1>hello world</h1>} />
          </Route> */}
      </Routes>
    </Suspense>
  );
};

export default AppRoutes;
